import { PureComponent } from 'react';
import { DragSource, DropTarget } from 'react-dnd';

import { isNonNullable } from '@ipfabric/utils';
import { Button } from 'components/Button/Button';
import PropTypes from 'prop-types';
import handleEvent from 'utils/handleEvent';
import OverviewPropTypes from '../../../../OverviewPropTypes';
import WeightInput from './WeightInput';

const columnSource = {
  beginDrag(props) {
    return {
      childIndex: props.childIndex,
      type: 'addWidgetReport',
    };
  },
};

const columnTarget = {
  drop(props, monitor) {
    const item = monitor.getItem();
    if (item.type === 'addWidgetReport') {
      const dragIndex = item.childIndex;
      const hoverIndex = props.childIndex;

      if (dragIndex === hoverIndex) {
        return;
      }
      props.onSortReport(dragIndex, hoverIndex);
      monitor.getItem().childIndex = hoverIndex;
    }
  },
};

/**
 * Colum of the dashboard grid. A column holds multiple widgets.
 */
@DropTarget('addWidgetReport', columnTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))
@DragSource('addWidgetReport', columnSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))
export default class Report extends PureComponent {
  static propTypes = {
    child: PropTypes.object.isRequired,
    childId: PropTypes.string.isRequired,
    childIndex: PropTypes.number.isRequired,
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    errors: OverviewPropTypes.errors,
    foundReport: PropTypes.object.isRequired,
    isOver: PropTypes.bool.isRequired,
    onDeleteReportFromGroup: PropTypes.func.isRequired,
    onWeightChange: PropTypes.func.isRequired,
    path: PropTypes.array.isRequired,
    reportsInGroup: OverviewPropTypes.reportsInGroup,
  };

  handleRemoveReportFromGroup = (reportId) =>
    handleEvent((e) => {
      const disableRemove = e.target.getAttribute('data-disableremove');
      if (isNonNullable(reportId) && disableRemove !== '1') {
        const { reportsInGroup, onDeleteReportFromGroup } = this.props;
        const foundIndex = reportsInGroup.findIndex(
          (child) => child.id === reportId,
        );
        if (foundIndex > -1) {
          onDeleteReportFromGroup(reportId);
        }
      }
    });

  render() {
    const {
      child,
      childId,
      childIndex,
      connectDragSource,
      connectDropTarget,
      errors,
      foundReport,
      isOver,
      onWeightChange,
      path,
    } = this.props;
    return connectDragSource(
      connectDropTarget(
        <tr
          key={childId}
          onDoubleClick={this.handleRemoveReportFromGroup(childId)}
          className={`addwidget-group-report${isOver ? ' over' : ''}`}
        >
          <td className='dashboard-color-form__groups-td'>
            <i className='fa-regular fa-file-lines mr-1' /> {foundReport.name}
            <span className='dashboard-color-form__group-report-path'>
              (
              <span className='dashboard-color-form__group-report-path-text'>
                {path.filter((v) => isNonNullable(v) && v !== '').join(' > ')}
              </span>
              )
            </span>
          </td>
          <td className='dashboard-color-form__groups-td'>
            <WeightInput
              errors={errors}
              onWeightChange={onWeightChange}
              reportId={foundReport.id}
              reportIndex={childIndex}
              weight={child.weight}
            />
          </td>
          <td className='dashboard-color-form__groups-td'>
            <Button
              variant='tertiary'
              icon='fa-xmark'
              size='xxs'
              type='button'
              onClick={this.handleRemoveReportFromGroup(childId)}
            />
          </td>
        </tr>,
      ),
    );
  }
}
